import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import Lock from "../icon/Lock";
import RemoveIcon from "../icon/RemoveIcon";
import "../style/cart.scss";
import { useSelector, useDispatch } from "react-redux";
import { removeItem } from "../store/cartSlice";
import { routeToPage } from "../util/RouteToPage";
import PagePath from "../util/RoutePagePath";
import Number from "./common/Number";
import { currency } from "./common/Common";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const total = cartItems.reduce(
    (sum, item) => sum + item.total * item.quantity,
    0,
  );

  const removeItemFormCart = (id) => {
    dispatch(removeItem(id));
  };

  return (
    <React.Fragment>
      <HeaderBar />

      <div className="min-h-screen bg-white px-6 py-12 lg:px-12">
        <div className="mx-auto max-w-7xl">
          {/* title */}
          <div className="mb-12">
            <h1 className="text-3xl font-light uppercase tracking-[0.2em]">
              Shopping Cart
            </h1>
            <p className="mt-2 text-sm text-gray-500">
              {cartItems.length} item(s)
            </p>
          </div>

          {cartItems.length > 0 ? (
            <div className="grid gap-16 lg:grid-cols-[1fr_380px]">
              {/* left */}
              <div>
                {cartItems.map((item, index) => (
                  <div
                    key={index}
                    className="flex gap-6 border-b border-gray-200 py-8"
                  >
                    {/* image */}
                    <div className="h-32 w-32 flex-shrink-0 overflow-hidden rounded-lg bg-gray-100">
                      <img
                        src={item?.image?.[0]}
                        alt=""
                        className="h-full w-full object-cover"
                      />
                    </div>

                    {/* info */}
                    <div className="flex flex-1 flex-col justify-between">
                      <div>
                        <div className="flex items-start justify-between">
                          <h3 className="max-w-md text-[15px] font-medium text-black">
                            {item.title}
                          </h3>

                          <button
                            onClick={() => removeItemFormCart(item.id)}
                            className="text-xs uppercase tracking-wider text-gray-400 transition hover:text-black"
                          >
                            Remove
                          </button>
                        </div>

                        <div className="mt-3 text-sm text-gray-500">
                          Item Price: {currency}
                          {(item.total / item.quantity).toFixed(2)}
                        </div>
                      </div>

                      <div className="mt-6 flex items-center justify-between">
                        <div className="w-fit rounded-full border border-gray-300 px-4 py-2">
                          <Number id={item.id} num={item.quantity} />
                        </div>

                        <div className="text-lg font-medium">
                          {currency}
                          {item?.total?.toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* right */}
              <div>
                <div className="sticky top-24 rounded-2xl border border-gray-200 bg-gray-50 p-8">
                  <h2 className="mb-8 text-lg font-medium uppercase">
                    Order Summary
                  </h2>

                  <div className="space-y-5 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-500">
                        Subtotal (Tax Included)
                      </span>
                      <span>
                        {currency}
                        {total.toFixed(2)}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-gray-500">Delivery</span>
                      <span>Free</span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-gray-500">Tax Included</span>
                      <span>0.00</span>
                    </div>

                    <div className="border-t pt-5">
                      <div className="flex justify-between text-lg font-semibold">
                        <span>Total</span>
                        <span>
                          {currency}
                          {total.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={() =>
                      routeToPage(navigate, PagePath.CHECKOUT_PAGE)
                    }
                    className="mt-8 w-full bg-black py-4 text-sm uppercase tracking-[0.15em] text-white transition hover:opacity-90"
                  >
                    Checkout
                  </button>

                  <button
                    onClick={() => routeToPage(navigate, PagePath.HOME_PAGE)}
                    className="mt-3 w-full border border-black py-4 text-sm uppercase tracking-[0.15em] transition hover:bg-black hover:text-white"
                  >
                    Continue Shopping
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center py-24">
              <div className="mb-4 text-xl font-light">Your cart is empty</div>

              <p className="mb-8 text-sm text-gray-500">
                Looks like you haven't added anything yet.
              </p>

              <button
                onClick={() => routeToPage(navigate, PagePath.HOME_PAGE)}
                className="bg-black px-10 py-4 text-sm uppercase tracking-[0.15em] text-white transition hover:opacity-90"
              >
                Shop Now
              </button>
            </div>
          )}
        </div>
      </div>

      <FooterBar />
    </React.Fragment>
  );
};

export default Cart;
